
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/policies-and-procedures",
      function () {
        return require("private-next-pages/policies-and-procedures/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/policies-and-procedures"])
      });
    }
  